{
  "GENERAL": {
    "CLOSE": "Mbyll",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Search",
      "EMPTY_STATE": "No results found"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Kërkohen të paktën {count}"
  }
}
